"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = void 0;
var classes = {
  switch: "bds-switch",
  switchContainer: "bds-switch-container",
  switchOn: "bds-switch-on",
  switchOff: "bds-switch-off",
  switchErrorMessage: "bds-switch-error-message",
  disabled: "disabled"
};
exports.classes = classes;